import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',

    routes: [
        {
            path: '/index',
            name: '音乐壳-专注少儿音乐启蒙教育',
            component: () => import('../pages/index.vue'),
            meta: {
                title: '音乐壳-专注少儿音乐启蒙教育'
            },
            children: [
                {
                    path: '/home',
                    component: () => import('../views/home.vue'),
                    meta: {
                        name: '音乐壳-专注少儿音乐启蒙教育'
                    }
                },
                {
                    path: '/course',
                    component: () => import('../views/course.vue'),
                    meta: {
                        name: '课程体系'
                    }
                },
                {
                    path: '/download',
                    component: () => import('../views/download.vue'),
                    meta: {
                        name: '下载中心'
                    }
                },
                {
                    path: '/about',
                    component: () => import('../views/about.vue'),
                    meta: {
                        name: '关于我们'
                    }
                },
                {
                    path: '',
                    redirect: '/home'
                }
            ]
        },
        {
            path: '*',
            redirect: '/index'
        }
    ]
});
router.beforeEach((to, from, next) => {
  if (location.href.includes('91yinyueke.com')) {
    to.meta.name = "北京音悦荚科技有限责任公司主页"
  }
  if (location.href.includes('ituner.top')) {
    to.meta.name = "音悦荚ai调音"
  }
  if (location.href.includes('aituner.top')) {
    to.meta.name = "音悦荚ai调音"
  }
  if (location.href.includes('tiaoyin.top')) {
    to.meta.name = "音悦荚ai调音"
  }
  next();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js